import { Modal } from 'antd';
import React from "react";

const ModalWapper = (props:any) => {
  const {MoadlProps,visible=false} = props
  return <>
  <Modal visible={visible} {...MoadlProps}>
    {
      <>11</>
    }
  </Modal>
  </>
}

export default ModalWapper